<!-- Plan Switcher -->
<div class="plan-switcher px-3 py-2 mb-2">
  <div class="relative">

    <!-- Button -->
    <button 
      (click)="togglePlanSwitcher($event)"
      class="w-full flex items-center justify-between px-3 py-2.5 bg-gradient-to-r from-gray-50 to-gray-100 dark:from-slate-800 dark:to-slate-800/80 rounded-xl text-sm font-medium border border-gray-200 dark:border-slate-700 hover:border-indigo-300 dark:hover:border-indigo-600 transition-all group"
    >
      <div class="flex items-center">

        @if (hasFormWizSubscription) {
          <span class="w-2.5 h-2.5 bg-indigo-500 rounded-full flex-shrink-0" [ngClass]="'mr-2.5 sidebar-text-mr'"></span>
          <span class="sidebar-text text-gray-700 dark:text-gray-200">{{ 'COMMON.ORGANIZATIONAL' | translate }}</span>
          <span class="sidebar-collapsed-only text-gray-700 dark:text-gray-200 font-semibold">E</span>
        } @else {
          <span class="w-2.5 h-2.5 bg-emerald-500 rounded-full flex-shrink-0" [ngClass]="'mr-2.5 sidebar-text-mr'"></span>
          <span class="sidebar-text text-gray-700 dark:text-gray-200">{{ 'COMMON.PERSONAL' | translate }}</span>
          <span class="sidebar-collapsed-only text-gray-700 dark:text-gray-200 font-semibold">P</span>
        }

      </div>

      <!-- <i 
        class="fas fa-chevron-down text-xs text-gray-400 transition-transform duration-200"
        [class.rotate-180]="isDropdownOpen"
      ></i> -->
    </button>

    <!-- Dropdown -->
    <!-- @if (isDropdownOpen) {
      <div 
        (click)="$event.stopPropagation()" 
        class="absolute top-full left-0 right-0 mt-1.5 bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-gray-200 dark:border-slate-700 z-50 overflow-hidden"
      >

        <a 
          routerLink="/essential/dashboard"
          (click)="isDropdownOpen = false"
          class="flex items-center justify-between px-3 py-2.5 hover:bg-gray-50 dark:hover:bg-slate-700/50 transition-colors cursor-pointer"
        >
          <div class="flex items-center">
            <span class="w-2.5 h-2.5 bg-emerald-500 rounded-full mr-2.5"></span>
            <div>
              <span class="text-sm font-medium text-gray-700 dark:text-gray-200">{{ 'COMMON.ESSENTIAL' | translate }}</span>
              <p class="text-xs text-gray-400 dark:text-gray-500">{{ 'COMMON.BASIC_FEATURES' | translate }}</p>
            </div>
          </div>

          @if (isEssential) {
            <span class="text-xs font-medium text-emerald-600 dark:text-emerald-400 px-2 py-0.5 rounded-full">
              {{ 'COMMON.ACTIVE' | translate }}
            </span>
          }

        </a>


        <div class="border-t border-gray-100 dark:border-slate-700"></div>


        <a 
          routerLink="/dashboard"
           (click)="isDropdownOpen = false"
          class="flex items-center justify-between px-3 py-2.5 hover:bg-gray-50 dark:hover:bg-slate-700/50 transition-colors cursor-pointer"
        >
          <div class="flex items-center">
            <span class="w-2.5 h-2.5 bg-indigo-500 rounded-full mr-2.5"></span>
            <div>
              <span class="text-sm font-medium text-gray-700 dark:text-gray-200">{{ 'COMMON.STANDARD' | translate }}</span>
              <p class="text-xs text-gray-400 dark:text-gray-500">{{ 'COMMON.FULL_FEATURES' | translate }}</p>
            </div>
          </div>

          @if (!isEssential) {
            <span class="text-xs font-medium text-indigo-600 dark:text-indigo-400 px-2 py-0.5 rounded-full">
              {{ 'COMMON.ACTIVE' | translate }}
            </span>
          }

        </a>

      </div>
    } -->

  </div>
</div>